import { ReactNode } from "react";

// The single page shell. Replaces the hand-copied
// `min-h-screen rounded-2xl border … bg-white p-5 … xl:p-10` markup across pages.
export default function PageContainer({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={`min-h-screen rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] xl:p-10 ${className}`}
    >
      {children}
    </div>
  );
}
